export const CANCELLATION_REASON_LABELS = {
  schedule_conflict: "Schedule conflict",
  no_longer_needed: "No longer needed",
  booked_by_mistake: "Booked by mistake",
  found_other_option: "Found another option",
  price_or_budget: "Price or budget concerns",
  location_issue: "Location issue",
  emergency: "Emergency",
  unable_to_fulfill: "Unable to fulfill service",
  client_unresponsive: "Client unresponsive",
  payment_or_policy_issue: "Payment or policy issue",
  other: "Other",
};

export const CUSTOMER_CANCELLATION_REASON_OPTIONS = [
  "schedule_conflict",
  "no_longer_needed",
  "booked_by_mistake",
  "found_other_option",
  "price_or_budget",
  "location_issue",
  "other",
];

export const PROFESSIONAL_CANCELLATION_REASON_OPTIONS = [
  "schedule_conflict",
  "emergency",
  "unable_to_fulfill",
  "client_unresponsive",
  "payment_or_policy_issue",
  "other",
];

export const getCancellationReasonOptions = (cancelledBy = "customer") => {
  const codes =
    cancelledBy === "professional"
      ? PROFESSIONAL_CANCELLATION_REASON_OPTIONS
      : CUSTOMER_CANCELLATION_REASON_OPTIONS;

  return codes.map((code) => ({
    value: code,
    label: CANCELLATION_REASON_LABELS[code] || "Other",
  }));
};

export const getCancellationReasonLabel = (code) =>
  CANCELLATION_REASON_LABELS[code] || "Other";

export const getCancellationDisplayText = (cancellation = {}) => {
  if (!cancellation) return "Not provided";

  const reason =
    (typeof cancellation.reason === "string" && cancellation.reason.trim()) ||
    getCancellationReasonLabel(cancellation.reasonCode);
  const note =
    typeof cancellation.reasonNote === "string" ? cancellation.reasonNote.trim() : "";

  if (note) {
    return reason ? `${reason}: ${note}` : note;
  }

  return reason || "Not provided";
};

export const getCancelledByLabel = (cancelledBy) => {
  if (cancelledBy === "professional") return "Professional";
  if (cancelledBy === "customer") return "Customer";
  return "Unknown";
};
